import { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";
import { PERMS } from "@/lib/perm";

let cache = null;
const useLocations = () => {
  const [items, setItems] = useState(cache || []);
  useEffect(() => { api.get("/locations").then((r) => { cache = r.data; setItems(r.data); }); }, []);
  return items;
};

export function LocationField({ value, onChange }) {
  const locs = useLocations();
  if (!locs.length) {
    return <div className="space-y-1.5"><Label>Sede</Label><Input value={value} onChange={(e) => onChange(e.target.value)} data-testid="user-location-input" /></div>;
  }
  return (
    <div className="space-y-1.5">
      <Label>Sede / punto vendita</Label>
      <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
        <SelectTrigger data-testid="user-location-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Nessuna</SelectItem>
          {value && !locs.some((l) => l.name === value) && <SelectItem value={value}>{value}</SelectItem>}
          {locs.map((l) => <SelectItem key={l.id} value={l.name}>{l.name}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

export function ManagerFields({ f, setF }) {
  const locs = useLocations();
  const perms = f.permissions || [];
  const toggle = (k) => setF({ ...f, permissions: perms.includes(k) ? perms.filter((p) => p !== k) : [...perms, k] });
  return (
    <div className="space-y-3 rounded-md border border-primary/40 bg-primary/5 p-3" data-testid="manager-fields">
      <p className="text-sm font-medium">Permessi del responsabile</p>
      <div className="grid gap-2 sm:grid-cols-2">
        {PERMS.map(([k, l]) => (
          <label key={k} className="flex cursor-pointer items-center gap-2 text-sm">
            <Checkbox checked={perms.includes(k)} onCheckedChange={() => toggle(k)} data-testid={`manager-perm-${k}`} />{l}
          </label>
        ))}
      </div>
      <div className="space-y-1.5">
        <Label>Limitato alla sede</Label>
        <Select value={f.manager_location || "all"} onValueChange={(v) => setF({ ...f, manager_location: v === "all" ? "" : v })}>
          <SelectTrigger data-testid="manager-location-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tutte le sedi</SelectItem>
            {locs.map((l) => <SelectItem key={l.id} value={l.name}>{l.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
